// src/Hooks/useMapSearch.js

import { useEffect, useRef } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../Firebase/firebase';
import { smoothFlyTo } from '../Components/GoogleMap/CameraAnimator';

// We add 'onMarkerClick' as a new argument to communicate back to the app
export const useMapSearch = (mapInstance, searchMarker, isMapLoaded, onMarkerClick) => {
  const searchMarkerRef = useRef(null);

  // --- BUG FIX: STORE CALLBACK IN REF ---
  // This prevents the useEffect below from re-running and triggering smoothFlyTo
  // every time a new marker is selected in the UI panels.
  const onMarkerClickRef = useRef(onMarkerClick);
  useEffect(() => {
    onMarkerClickRef.current = onMarkerClick;
  }, [onMarkerClick]);

  useEffect(() => {
    if (!isMapLoaded || !mapInstance.current || !window.google) return;

    // 1. Cleanup previous marker
    if (searchMarkerRef.current) {
      searchMarkerRef.current.map = null;
      searchMarkerRef.current = null;
    }

    if (searchMarker) {
      // 2. Create the Pin (Modern Style)
      const pin = new window.google.maps.marker.PinElement({
        background: '#EA4335',
        borderColor: '#B31412',
        glyphColor: 'white',
      });

      // 3. Create the Marker
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        map: mapInstance.current,
        position: { lat: searchMarker.lat, lng: searchMarker.lng },
        title: searchMarker.name,
        content: pin, // FIX: Pass the pin directly (it is an HTML Element now)
        // AMENDED: Ensure search result pins never disappear
        collisionBehavior: window.google.maps.CollisionBehavior.REQUIRED,
      });

      // 4. ADD THE LISTENER
      // We listen for the specific 'gmp-click' event on the marker
      marker.addListener('gmp-click', async () => {
        // --- PERMISSION CHECK START ---
        let canUpdate = false;
        const user = auth.currentUser;

        if (user && user.email) {
          try {
            const emailKey = user.email.toLowerCase().trim();
            const permRef = doc(db, 'permittedUsers', emailKey);
            const permSnap = await getDoc(permRef);

            if (permSnap.exists()) {
              const permData = permSnap.data();
              canUpdate = permData.canUpdateMarkers === true;
            }
          } catch (error) {
            console.error('Error checking marker permissions:', error);
          }
        }

        if (canUpdate) {
          // 5a. PERMITTED: Proceed to open the conversion dialog
          // Use the ref to ensure we always call the most current function without causing re-renders
          if (onMarkerClickRef.current) {
            onMarkerClickRef.current({
              id: `search-result-${Date.now()}`,
              ...searchMarker,
              type: 'search-result',
            });
          }
        } else {
          // 5b. DENIED: Just make the marker disappear
          marker.map = null;
          searchMarkerRef.current = null;
        }
        // --- PERMISSION CHECK END ---
      });

      searchMarkerRef.current = marker;

      // 6. Fly to location
      smoothFlyTo(mapInstance.current, searchMarker.lat, searchMarker.lng, 17);
    }
    // FIX: Removed onMarkerClick from this array to break the infinite flying loop
  }, [searchMarker, isMapLoaded, mapInstance]);
};
